import gql from 'graphql-tag';
import { mutation } from 'services/graphql';

export const linkSurfaceNodesMutation = gql`
  mutation linkSurfaceNodes($input: LinkSurfaceNodesInput!) {
    linkSurfaceNodes(input: $input) {
      error
      success
    }
  }
`;

export default mutation(linkSurfaceNodesMutation);
